import React, { Component } from 'react';

import LogoZBorder from '../SVG/LogoZBorder';
import NavButton from './NavButton';
import PermissionManager from '../../managers/PermissionManager'

export default class Nav extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}
        this.pm = new PermissionManager();
        this.state = {
            accountInfo: {
                email: "",
                firstName: "",
                lastName: "",
                avatarUrl: "",
                isDashboardOnly: false,
                leaderboardOnly: false
            },
            imageDidError: false
        }

        this.handleImageError = this.handleImageError.bind(this);

        this.imageCheckStatus = 0;

        let self = this;
        this.props.dbm.getAccountInfo().then((accountInfo) => {
            if (accountInfo != undefined) {
                self.setState({ accountInfo: accountInfo });
            }
        }).catch((err) => {

        })

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.accountInfo != null && prevProps.accountInfo != null && this.props.accountInfo.avatarUrl != prevProps.accountInfo.avatarUrl) {
            this.imageCheckStatus = 0;
        }
    }

    handleImageError() {
        if (!this.state.imageDidError) {
            this.setState({ imageDidError: true })
        }
    }

    viewPrivacyPolicy(ignore) {
        if (usingiOS && window.hasOwnProperty('cordova')) {
                cordova.InAppBrowser.open('https://company.mindbodyonline.com/legal/privacy-policy', '_system');
        }
        else {
            window.open('https://company.mindbodyonline.com/legal/privacy-policy', '_system');
            }
        return false;
    }

    render() {

        let userIdentity = this.props.accountInfo != null ? this.props.accountInfo : { avatarUrl: null, firstName: "", lastName: "", email: "", userType: 6, isDashboardOnly: false, leaderboardOnly: false };

        let avUrl = userIdentity.avatarUrl;
        if (avUrl != null && !avUrl.includes('?')) {
            avUrl += "?v=" + this.props.picV;
        }

        let imageJsx = (<img className="nav-userpic" onError={this.handleImageError} alt={""} src={userIdentity.avatarUrl === null ? '' : avUrl} />);
        if (userIdentity.avatarUrl != null) {
            if (this.imageCheckStatus === 0) {
                this.imageCheckStatus = 1;
                if (avUrl === null ||
                    ((avUrl.includes(window.__globalConfig.baseUrl) || avUrl.includes('https://green.gozeezor.com')) &&
                        this.state.imageDidError)) {

                    this.imageCheckStatus = 2;
                    imageJsx = <div className="material-icons nav-userpic-notfound">person</div>
                }
            } else {
                if (avUrl === null ||
                    ((avUrl.includes(window.__globalConfig.baseUrl) || avUrl.includes('https://green.gozeezor.com')) &&
                        this.imageCheckStatus === 2)) {
                    imageJsx = <div className="material-icons nav-userpic-notfound">person</div>
                }
            }
        } else {
            imageJsx = <div className="material-icons nav-userpic-notfound">person</div>
        }

        let permMetric = !this.props.isAaBiDashboardOnly && !userIdentity.isDashboardOnly && this.pm.hasAccess(this.pm.PERMISSIONS.METRICS);
        let permStackup = !this.props.isAaBiDashboardOnly && !userIdentity.isDashboardOnly && this.pm.hasAccess(this.pm.PERMISSIONS.STACKUP) && (!userIdentity.isEmployeeLocked || userIdentity.userType < 5);
        let permStackupFree = this.pm.hasAccess(this.pm.PERMISSIONS.STACKUPFREE);
        let permReporting = !this.props.isAaBiDashboardOnly && !userIdentity.isDashboardOnly && this.pm.hasAccess(this.pm.PERMISSIONS.REPORTING);
        let permChat = this.pm.hasAccess(this.pm.PERMISSIONS.CHAT);
        let permGroup = !this.props.isAaBiDashboardOnly && !userIdentity.isDashboardOnly && this.pm.hasAccess(this.pm.PERMISSIONS.GROUPS);
        let permManage = !this.props.isAaBiDashboardOnly && !userIdentity.isDashboardOnly && this.pm.hasAccess(this.pm.PERMISSIONS.MANGEMENT);
        let permWorkspace = this.state.accountInfo.allowDashboards && !this.props.isPhone;
        let disableItems = false;


        return (
            <div id="nav-outer" className={this.props.isOpen ? 'nav-outer--active' : null}>
                <div onClick={this.props.toggleNav} className="nav-shadow"></div>
                <div className="nav-main-container">
                    <div className="nav-top-section">
                        <div onClick={this.props.toggleNav} className="nav-zlogo-container">
                            {/* <LogoZBorder className="nav-zlogo" /> */}
                            <img className={"nav-mindbody-logo"} src={window.hasOwnProperty("cordova") === true ? __globalConfig.contentUrl + "./images/mb-business-logo-white-fixed.svg" : __globalConfig.contentUrl + "/images/mb-business-logo-white-fixed.svg"} />
                        </div>
                        <div className="nav-userinfo-container">
                            <div className="nav-userpic-container">
                                {imageJsx}
                            </div>
                            <div className="nav-usertext-container">
                                <div className="nav-username">{userIdentity.firstName + " " + userIdentity.lastName}</div>
                                <div className="nav-useremail">{userIdentity.email}</div>
                            </div>
                        </div>
                    </div>
                    <div className="nav-bottom-section">
                        {permWorkspace ? <NavButton icon={"dashboard"} title={'Dashboards'} pageName={'dashboards'} changePage={this.props.changePage} /> : null}
                        {permMetric ? <NavButton icon={"equalizer"} title={'Leaderboard'} pageName={'leaderboard'} changePage={this.props.changePage} /> : null}
                        {permStackup && disableItems ? <NavButton icon={"layers"} title={'Stack-Up'} pageName={'stackup'} changePage={this.props.changePage} /> : null}
                        {/* {permStackupFree ? <NavButton icon={"layers"} title={'Stack-Up Lite'} pageName={'stackupfree'} changePage={this.props.changePage} /> : null} */}
                        {permReporting && disableItems ? <NavButton icon={"find_in_page"} title={'Reporting'} pageName={'reporting'} changePage={this.props.changePage} /> : null}
                        {/* {permChat ? <NavButton icon={"chat"} title={'ZeeZor Chat'} pageName={'chat'} changePage={this.props.changePage} /> : null} */}
                        {permGroup ? <NavButton icon={"group"} title={'Groups'} pageName={'groups'} changePage={this.props.changePage} /> : null}
                        <NavButton icon={"person"} title={'Profile'} pageName={'profile'} changePage={this.props.changePage} />
                        {permManage ? <NavButton icon={"settings"} title={'Engage'} pageName={'engage'} changePage={this.props.changePage} /> : null}
                        <div className="nav-button-separator"></div>
                        {/* <NavButton icon={"help_outline"} title={'Tutorials'} overrideFunction={this.props.tutorialOn} /> */}
                        {/* <NavButton icon={"touch_app"} title={'Demo'} overrideFunction={this.props.demoOn} /> */}
                        <NavButton icon={"feedback"} title={'Feedback'} pageName={'feedback'} changePage={this.props.changePage} />
                        <NavButton icon={"policy"} title={'Privacy Policy'} pageName={'policy'} changePage={this.viewPrivacyPolicy} />
                        <NavButton icon={"exit_to_app"} title={'Log Out'} pageName={''} changePage={this.props.changePage} logout={this.props.logout} />
                    </div>
                </div>
            </div>
        );
    }
}
